import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { OktaAuthService } from '@okta/okta-angular';
import * as OktaSignIn from '@okta/okta-signin-widget';
import { AuthService } from '../auth/auth.service';
import { LoadingService } from '../shared/loading/loading.service';
import { ApiConstants } from '../shared/constants/api.constants';
import { AppConstants } from '../shared/constants/app.constants';

import { LocalStorageService } from '../shared/services/localStorage.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { oktaLoginService } from './okta-login.service';
import { AlertService } from '../shared/alerts/alerts.service';

@Component({
  selector: 'app-secure',
  template: require('./okta-login.template.html'),
  encapsulation: ViewEncapsulation.None,
  styles: [
      require('./okta-login.stylesheet.scss'),
      require('../shared/styles/form.scss')
    ]
})
export class oLoginComponent  implements OnInit, AfterViewInit {
  @ViewChild('userNameInput') private userNameInput: ElementRef;
  signIn;
  private baseUrl = this.apiConstants.baseUrl;
  private redirectUrl = this.baseUrl + '/login/redirect';
  private accountId: string;
  private widget;
  dummySignIn: FormGroup;
  showDummySignIn = false;
  showBackOption = false;

  constructor(
      oktaAuth: OktaAuthService,
      private authService: AuthService,
      private loadingService: LoadingService,
      private localStorageService: LocalStorageService,
      private route: ActivatedRoute,
      private apiConstants: ApiConstants,
      private router: Router,
      private fb: FormBuilder,
      private oktaLoginService: oktaLoginService,
      private alertService: AlertService,
    ) {
    this.signIn = oktaAuth;
  }

  initializeDummySignIn() {
    this.dummySignIn = this.fb.group({
      username: [ '', [ Validators.required, Validators.pattern(/[\S]/) ] ]
    });
  }

  triggerOktaClick() {
    setTimeout(() => {
      document.getElementById('idp-discovery-submit').click();
    }, 100);
  }

  onBack() {
    this.showDummySignIn = true;
    this.showBackOption = false;
    this.widget.remove();
  }

  onNext() {
    const isValueUsername = _.get(this.dummySignIn, 'controls.username.value', '');

    if ( isValueUsername.trim() ) {
      const resource = this.dummySignIn.value.username;
      const baseUrl = AppConstants.getBaseUrl();
      this.oktaLoginService.getWebFingerConfig(resource, baseUrl)
        .switchMap(res => {
          const und = _.get(res, 'links[0].titles.und', '');
          // const type = _.get(res, 'links[0].properties["okta:idp:type"]', '');
          return this.oktaLoginService.getRequestContext(und);
        })
        .subscribe((data) => {
          this.showDummySignIn = false;
          this.showBackOption = true;
          this.initializeOktaWidget(resource, data.relayState);
          this.showOktaLogin();
          this.triggerOktaClick();
        }, () => {
          this.alertService.createAlert(true, true, 'Something went wrong!');
        });
    } else  {
      this.dummySignIn.get('username').markAsDirty();
    }
  }

  ngAfterViewInit() {
    if ( this.userNameInput ) {
      this.userNameInput.nativeElement.focus();
    }
  }

  ngOnInit() {
    this.initializeDummySignIn();

    this.loadingService.showLoading();
    this.authService.validateSession()
      .finally(() => this.loadingService.hideLoading())
      .subscribe(() => {
        this.router.navigate(['login/tenant']);
      }, () => this.showDummySignIn = true);

    this.route.params.subscribe( (params: Params) => {
      let accountId = params['accountId'];
      if ( !!accountId && (accountId !== 'login') && ( accountId !== this.accountId) ) {
        this.accountId = accountId;
        this.localStorageService.set( 'loginAccount', {'id': this.accountId} );
        this.router.navigate([ '/', 'login' ]);
      }
      if ( !accountId ) {
        let accountInfo: any = this.localStorageService.get('loginAccount');
        if ( !!accountInfo ) {
          this.accountId = accountInfo['id'];
        }
      }
      this.authService.validateRedirectUrl( this.router.url);
    });
  }

  showOktaLogin() {
    this.widget.renderEl({
      el: '#okta-signin-container'},
      (res) => {
        if (res.status === 'SUCCESS') {
          this.signIn.loginRedirect('/', { sessionToken: res.session.token });
          // Hide the widget
          this.widget.hide();
        }

        if ( res.status === 'IDP_DISCOVERY' ) {
          res.idpDiscovery.redirectToIdp('');
        }
      },
      (err) => {
        throw err;
      }
    );
  }

  checkEmailBtn() {
    let ele = document.querySelector('.password-reset-email-sent a'); 
    return !!ele;
  }

  initializeOktaWidget(user?, requestContext?) {
    let config = {
      baseUrl: AppConstants.getBaseUrl(),
      clientId: AppConstants.getClientId(),
      redirectUri: this.redirectUrl,
      username: user,
      idpDiscovery: {
        requestContext: requestContext,
      },
      authParams: {
        issuer: 'default',
        responseType: ['code'],
        scopes: ['openid', 'email', 'profile'],
      },
      i18n: {
        'en': {
          'primaryauth.title': ' ',
          'password.expired.title': 'Your password has expired.',
          'errors.E0000004': 'Invalid credentials or user is locked. Please contact administrator.',
          'signout': 'Back to Sign In',
          'password.forgot.email.or.username.placeholder': 'Username',
          'password.forgot.emailSent.desc': 'If an account for {0} exists, a reset link will be sent to the email shortly.'
        }
      },
      features: {
        rememberMe: false,
        idpDiscovery: true,
        selfServicePasswordReset: true
      }
    };

    if ( !!this.accountId ) {
      config['transformUsername'] =  (username, operation) => {
        console.log( operation);
        return username;
      };
    }
    this.widget = new OktaSignIn(config);
  }

  // TODO: Integrate getCofig API to fetch url/clientId dynamically.

  // getConfig() {
  //   let params = null;
  //   this.oLoginService.getConfig( params).subscribe(config => {
  //     this.config = config;
  //     this.initializeOktaWidget();
  //   }, err => this.loginError(err,));
  // }

  // loginError(error: any) {
  //   let data;
  //   try {
  //     data = JSON.parse(error._body);
  //   } catch (e) { }

  //   let errMsg = (data && (data.message || data.error)) || 'Error Occurred.';
  //   console.error( JSON.stringify(errMsg));
  //   this.loadingService.hideLoading();
  // }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/okta-login/okta-login.component.ts